export const stepOneData = [
  {
    stepOneHeading: "Maximizing Your Loan Affordability:",
    paraOne:
      "Once you’ve calculated how much loan you can afford, there are additional strategies you can consider to increase your eligibility and potentially secure better loan terms:",

    stepOneList: [
      {
        id: 1,
        head: "Apply with a Co-Applicant: ",
        info: "Adding a co-applicant can increase your combined loan eligibility, especially if they have a stable income.",
      },
      {
        id: 2,
        head: "Include Additional Income Sources: ",
        info: "Adding supplementary income sources, like rental or freelance income, can improve your financial profile.",
      },
      {
        id: 3,
        head: "Consider the Purpose of the Investment: ",
        info: "Affordability can vary depending on the property’s intended use. Rental income or business purposes may offset EMI costs.",
      },
      {
        id: 4,
        head: "Adjust Your Loan Tenure: ",
        info: "A longer tenure can reduce monthly EMIs, though it may increase overall interest.",
      },
      {
        id: 5,
        head: "Prepayment Options: ",
        info: "Look for loans that allow prepayments without penalties, which can help reduce interest over time.",
      },
      {
        id: 6,
        head: "Optimize Your Credit Profile: ",
        info: " A higher credit score improves eligibility and access to better loan terms.",
      },
    ],
    tip: "Check your credit score for free on Minemi, and review your credit report for any errors. Correct inaccuracies, prioritize timely payments, and maintain low credit utilization to improve your loan eligibility and access better terms.",
  },
];

export const stepTwoData = [
  {
    stepTwoHeading: "Lower Your EMI with Minemi:",
    paraOne:
      "Did you know that reviewing your credit profile and exploring new loan options could help you reduce your existing EMIs? With Minemi, you can see if a new loan with better terms is available to help ease your monthly payments.",

    paraTwo:
      "If you’re putting down less than 20% on the home, you’ll have to pay private mortgage insurance, or PMI. This is often a few hundred dollars per month. Closing costs are typically equal to 2% to 6% of the price of the home, which comes out to thousands (or tens of thousands) of dollars.",
  },
];

export const stepThreeData = [
  {
    stepThreeHeading: "What mortgage can I afford?",
    stepThreeSubHeadOne:
      "It’s not what you can borrow, it’s what you can afford",
    paraOne:
      "In some respects, the mortgage lending industry is working against your best interest. If you are deemed a qualified borrower, a lender is prone to approve you for the maximum it believes you can afford. But in some cases, that amount may be too generous.",
    paraTwo:
      "Buying a home always means dealing with big numbers. And the impact on your budget may seem to be a stretch, particularly in the beginning. The challenge is buying a home that meets your current and future needs, without feeling like all of your money is in your home, leaving you without the financial freedom to travel, save for other priorities and have a cash flow cushion.",

    paraThree:
      "Consider the 28% rule, which states that mortgage payments shouldn’t be more than 28% of your pre-tax monthly income. If you’re not comfortable with nearly a third of your income going toward your mortgage, you’ll want to avoid shopping at the top of your budget.",
    paraFour:
      'Now that the NerdWallet "How much can I borrow calculator" has given you an idea of your buying power, you may want to gut-check the number with these next steps.',
    stepThreeListOne: [
      {
        id: 1,
        listHead: "Run affordability scenarios. ",
        listPara:
          "You can get another view of your homebuying budget by running some what-ifs through the NerdWallet home affordability calculator.",
      },
      {
        id: 2,
        listHead: "Talk to more than one lender. ",
        listPara:
          "You are more likely to get a better interest rate by comparing terms offered by multiple lenders, and it might be illuminating to see the loan amounts different lenders will qualify you for.",
      },
      {
        id: 3,
        listHead: "Consider all homeownership expenses. ",
        listPara:
          "It’s not just what’s built into your monthly payment — such as insurance, taxes and the rest — but the other having-a-home expenses, like structural upkeep, new furniture, or yard maintenance equipment.",
      },
    ],
    stepThreeSubHeadTwo: "What factors affect the amount you can borrow",
    paraFive:
      "Lenders consider several factors in determining the amount you qualify for, including:",
    stepThreeListTwo: [
      {
        id: 1,
        listHead: "Your debt-to-income ratio. ",
        listPara:
          "Typically, lenders will want your total debts to account for no more than 36% of your monthly income. You can use our debt-to-income ratio calculator to help you find this figure.",
      },
      {
        id: 2,
        listHead: "Your loan-to-value ratio. ",
        listPara:
          "This ratio is a function of the amount of money you put down. If you want to drill down on this calculation, use NerdWallet’s loan-to-value calculator.",
      },
      {
        id: 3,
        listHead: "Your credit score. ",
        listPara:
          "This number impacts the pricing of your loan more than how much you’ll qualify for, but the pricing of your loan is really important. Most lenders will require a minimum score of 620 in order to qualify. If you don’t know your score, get it here.",
      },
    ],
    stepThreeSubHeadThree: "How can I qualify to borrow more?",
    paraSix:
      'If you’re disappointed by the "how much can I borrow" results, remember that there are many factors at work. Small improvements in one or more factors can make a substantial difference:',
    stepThreeListThree: [
      {
        id: 1,
        listHead: "A bigger down payment always helps. ",
        listPara:
          "The more money you put down, the better you’ll look in the eyes of the lender.",
      },
      {
        id: 2,
        listHead: "Be a tactical buyer. ",
        listPara:
          "Consider your priorities at the current moment and think about any items on your wishlist that you can forgo for now; maybe buying a starter home rather than a forever home. For instance, if you hope to grow your family but don’t see yourself with school-age children in the near future, you may deemphasize school districts in your home search.",
      },
      {
        id: 3,
        listHead: "Reduce debt; even a little. ",
        listPara:
          "Paying off — or down — a credit card or two can help in several ways. Your debt-to-income ratio will go down and you may even get a nice bump in your credit score.",
      },
    ],
  },
];

export const stepFourData = [
  {
    stepFourHeading: "4. Get Principal Approval for Loan Offers",
    paraOne:
      "The information you need for refinancing a car loan varies by lender and where you are in the application process. The majority of lenders will request the following information at some point, so you can prepare by gathering everything ahead of time. ",
    infoList: [
      {
        info: "Your driver’s license.",
      },
      {
        info: "Vehicle registration.",
      },
      {
        info: "Proof of insurance.",
      },
      {
        info: "The vehicle identification number, or VIN, of your car.",
      },
      {
        info: "Pay stubs from your current employer or proof of employment.",
      },
      {
        info: "Your Social Security number.",
      },
      {
        info: "A statement of loan payoff amount from your current lender.",
      },
    ],
  },
];

export const stepFiveData = [
  {
    stepFiveHeading: "5. Compare lenders and rates",
    paraOne:
      "When possible, apply to several lenders that offer pre-qualification with a soft credit check. You’ll receive pre-qualified loan offers with rate and payment estimates, so you get an idea whether refinancing to a new loan will be an improvement. A soft credit check will not affect your credit score.",

    paraTwo:
      "An auto loan refinance calculator can help you compare pre-qualified loan offers to your existing loan. First enter information about your current loan: the original loan amount, interest rate and the length of the loan in months. Then enter the amount you want to refinance (usually your loan payoff amount) and the loan term and rates from your pre-qualified offers.",
    paraThree:
      "This will show you the amount you could potentially save on your monthly car payment and help you narrow down where you want to apply.",

    // para four comes after calculator
    paraFour:
      "Pay attention to auto loan terms when you compare loans. You can leave the length of your loan unchanged, but some loan offers may be for a longer term than you currently have.",
    paraFive:
      "Often, lenders suggest a longer term to lower your monthly payment. If your budget is stretched, a longer term can give you a little financial breathing room, but it also means you will pay more interest in the loan run. Still, that's better than missing payments and damaging your credit history.",
    paraSix:
      "Shortening the length of the loan is also an option. If your financial situation has improved, you could refinance to a shorter term, keep your monthly payment about the same and pay off the loan sooner. This saves you money because you’ll pay less interest over the life of the loan.",
  },
];

export const stepSixData = [
  {
    stepSixHeading: "6. Apply to refinance your car loan",
    paraOne:
      "Pre-qualification provides estimated offers and is not loan approval, so your last step is to get final loan approval from one or more lenders. Depending on what information the lender requested when you pre-qualified, you may need to provide more information for approval.",
    paraTwo:
      "If you decide to move to the approval phase with more than one lender in order to compare firm loan offers, do so within a 14-day period. Similar queries in this time period are typically grouped together and treated as one, which lessens the impact on your credit score.",
    paraThree:
      "Once you choose a lender and let it know you want to finalize refinancing your car, you’ll receive new loan documents to sign. Refinancing does start your auto loan over, so the lender will create a new loan with the new rate and term length you agreed on.",
    paraFour:
      "Your new lender will either pay off your old loan or provide the funds for you to do so. If your new lender says it will pay off the old loan, it’s still a good idea to follow up and make sure it did.",
    paraFive:
      "Your final step? Watch for information from your new lender about when and how to start making payments on your auto refinance loan.",
  },
];

export const stepSevenData = [
  {
    stepSevenHeading: "7. Sign the Loan Agreement and Receive Funds",
    paraOne:
      "After signing, the funds are typically disbursed within a few days. Many digital lenders offer same-day or next-day disbursal to your account, enabling you to use the funds promptly.",
    paraTwo:
      "Tip: Create a repayment plan to stay on top of EMIs, as your first payment is usually due 30 days after disbursal.",
    sucessTipOne:
      "If Denied, Improve for Next Time: If your application is denied, request feedback from the lender. This can guide you in strengthening your credit score or lowering your debt-to-income ratio to improve future approval chances.",
    sucessTipTwo:
      "Automate Payments: Setting up auto-pay can help ensure on-time payments, avoiding late fees and supporting a positive credit history.",
  },
];
